'use strict';

/**
 * @ngdoc directive
 * @name 360StoreAngularApp.directive:stCapabilitiesList
 * @description
 * # stCapabilitiesList
 */
angular.module('360StoreAngularApp')
	.directive('stCapabilitiesList', function () {
		return {
			restrict: 'E',
			scope: {
				capabilities: '<' // One-way binding for the capabilities object
			},
			template: `
            <ul class="capabilities-list">
              <li ng-if="capabilities.deviceCount >= 0">
                <span class="glyphicon glyphicon-phone"></span> {{ getDeviceCountText() }} Device{{ capabilities.deviceCount === 1 ? '' : 's' }}
              </li>
              <li ng-repeat="config in capabilities.configurations">
                <span class="glyphicon glyphicon-tasks"></span> {{ getConfigCountText(config) }} <span class="config-db-type-item" ng-repeat="dbType in config.databases track by $index"><code class="non-threatening">{{dbType}}</code></span> Config
              </li>
            </ul>
          `,
			controller: function ($scope) {
				const UNLIMITED_INT_VALUE = 2147483647;

				$scope.getDeviceCountText = function () {
					if (!$scope.capabilities) {
						return '0';
					}
					return $scope.capabilities.deviceCount === UNLIMITED_INT_VALUE ? 'Unlimited' : ($scope.capabilities.deviceCount || 0);
				};

				$scope.getConfigCountText = function (config) {
					if (!config) {
						return '0';
					}
					return config.count === UNLIMITED_INT_VALUE ? 'Unlimited' : (config.count || 0);
				};
			}
		};
	});
